var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.97256 18C6.66176 18 4.64896 17.2358 2.93416 15.7075C1.21937 14.1791 0.241317 12.2693 0 9.97791H2.27473C2.50751 11.6535 3.25776 13.0386 4.52547 14.1332C5.79316 15.2279 7.27553 15.7752 8.97256 15.7752C10.8658 15.7752 12.4717 15.1179 13.7904 13.8032C15.1091 12.4885 15.7685 10.8874 15.7685 9C15.7685 7.11256 15.1091 5.5115 13.7904 4.19681C12.4717 2.88212 10.8658 2.22478 8.97256 2.22478C7.89143 2.22478 6.87606 2.46899 5.92643 2.9574C4.97683 3.44582 4.17274 4.12301 3.51419 4.98897H6.04745V7.04417H0.00372742V1.03055H2.05351V3.24095C2.90681 2.20563 3.93621 1.40665 5.14172 0.843988C6.34722 0.281329 7.62417 0 8.97256 0C10.2221 0 11.395 0.237127 12.4913 0.711382C13.5875 1.18564 14.5418 1.82775 15.3543 2.63772C16.1667 3.44768 16.8108 4.39911 17.2865 5.49201C17.7622 6.58489 18 7.75422 18 9C18 10.2458 17.7622 11.4151 17.2865 12.508C16.8108 13.6009 16.1667 14.5523 15.3543 15.3623C14.5418 16.1722 13.5875 16.8144 12.4913 17.2886C11.395 17.7629 10.2221 18 8.97256 18ZM11.6897 13.154L7.96233 9.43793V4.11044H10.0121V8.60883L13.1334 11.7148L11.6897 13.154Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.e2b1f70a.svg";
export { ForwardRef as ReactComponent };